import React from "react";
import { TiWarning } from "react-icons/ti";

/**
 * Reusable banner for warning/callout content: icon and text centered.
 * Used by SMSCostWarning and any other warning-style callouts.
 *
 * @component
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Content to show (string or JSX, e.g. with <b> for emphasis)
 * @param {('warning'|'info'|'error')} [props.variant='warning'] - Visual style. 'warning' = orange (matches DispatchModal)
 * @param {React.ReactNode} [props.icon] - Icon element. If omitted, uses default warning icon
 */
export default function WarningBanner({ children, variant = "warning", icon }) {
  const variantStyles = {
    warning: "bg-orange-100 text-orange-500",
    info: "bg-blue-100 text-blue-600",
    error: "bg-red-100 text-red-600",
  };
  const style = variantStyles[variant] ?? variantStyles.warning;

  const defaultIcon =
    variant === "warning" ? (
      <TiWarning color="orange" size={30} />
    ) : (
      <TiWarning size={30} className={variant === "error" ? "text-red-500" : "text-blue-500"} />
    );
  const iconNode = icon ?? defaultIcon;

  return (
    <div
      className={`flex flex-row justify-center p-2 mt-4 rounded-md ${style}`}
      role="alert"
    >
      <div className="flex min-w-0 flex-row items-center">
        <div className="my-auto max-w-[100px] shrink-0">{iconNode}</div>
        <div className="text-md mx-4 my-auto min-w-0 whitespace-normal break-words text-center">
          {children}
        </div>
      </div>
    </div>
  );
}
